"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable implicit-arrow-linebreak */

/**
 * Schema for a Slide Asset
 * @param {ObjectId} objectIdType ObjectId type from mongoose package
 * @returns Defined Schema for a Slide Asset
 */
var SlideAsset = function SlideAsset(objectIdType) {
  if (!objectIdType) {
    throw new Error('objectIdType must be provided');
  }
  return {
    name: {
      type: String
    },
    range: [],
    action: {
      type: Number
    },
    startIndex: {
      type: Number
    },
    endIndex: {
      type: Number
    },
    type: {
      type: String
    },
    subType: {
      type: String
    },
    hideAfter: {
      type: Boolean
    },
    panelId: {
      type: objectIdType
    },
    resourceId: {
      type: objectIdType
    },
    className: {
      type: String
    },
    content: {
      type: Object
    },
    indexedContent: {
      type: String
    },
    // Used for Addition text and Answer Summary for bubble and Provision
    text: {
      type: String
    },
    // Used for Provision correct answer
    correct: {
      type: Boolean
    },
    /* Start Character Settings */
    speechBubbleOn: {
      type: Boolean
    },
    initialGreeting: {
      type: String
    },
    tryAgain: {
      type: String
    },
    feedback: {
      type: String
    },
    // Used for determining if Initial Greeting is appended to Try Again Text for Stateful
    includeInitial: {
      type: Boolean
    },
    /* End Character Settings */
    // Used for ignoring the end duration on the timeline
    ignoreEndDuration: {
      type: Boolean
    },
    // Used for Addition and Deletion to show marked/styled version
    showStyling: {
      type: Boolean
    },
    // Used currently for Addition and Deletion to include highlighting
    includeHighlight: {
      type: Boolean
    },
    // Used for Element-Level Annotations
    rootId: {
      type: String
    },
    elementId: {
      type: String
    },
    // Used for Addition Element and Dynamic Annotations
    styleId: {
      type: objectIdType
    },
    position: {
      type: String
    },
    // Used for CATA AnswerBase Annotations
    answerEdits: [{
      _id: objectIdType,
      type: {
        type: String
      },
      subType: {
        type: String
      },
      startIndex: {
        type: Number
      },
      endIndex: {
        type: Number
      },
      text: {
        type: String
      },
      // Used for Dynamic Annotations
      styleId: {
        type: objectIdType
      },
      // Used for Addition and Deletion to show marked/styled version
      showStyling: {
        type: Boolean
      },
      // Used for setting Annotation to hide on quiz on CATA Answer Edits
      hideForQuiz: {
        type: Boolean
      },
      // Used for setting Annotation to hide on feedback on CATA Answer Edits
      hideForFeedback: {
        type: Boolean
      },
      // Used for Additions when sourcing from a Text Resource
      resourceId: {
        type: objectIdType
      }
    }],
    // Used for setting Annotation to hide on quiz on non-Explainer slides
    hideForQuiz: {
      type: Boolean
    },
    // Used for setting Annotation to hide on feedback on non-Explainer slides
    hideForFeedback: {
      type: Boolean
    },
    // Used for ignoring autoscroll for Scrollable Annotations
    ignoreAutoscroll: {
      type: Boolean
    },
    // Used for associating Global Annotations with local Slide Annotations
    globalId: {
      type: objectIdType
    },
    // Used for grouping Global Annotations
    groupId: {
      type: objectIdType
    },
    // Used for ordering Global Annotations when processing
    order: {
      type: Number
    }
  };
};
var _default = SlideAsset;
exports["default"] = _default;